<sub-header [isModal]="true" [windowHash]=windowHash></sub-header>
<!--<p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1" *ngIf="isLoaded()">-->
<!-- En lugar de scrollpanel se establece un heigth máximo del textarea por estilos -->
<div class="container-fluid m-t-lg" *ngIf="isLoaded()">
  <div class="row">
    <form autocomplete="off">
      <div class="form-group col-12 ">
        <label *ngIf="!this.disabled" for="observations">{{(label&&label!='')?label+':':labelDefault}}</label>
        <div class="p-inputgroup">
          <textarea autofocus="autofocus" id="texto" [(ngModel)]="text" class="plForm-element form-control NOEDITABLE"
            name="texto" disabled="{{disabled?'disabled':'false'}}" [maxlength]="maxLong">
          </textarea>
        </div>
      </div>
    </form>
  </div>
</div>
<!--</p-scrollPanel>-->